exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar__header[data-v-0cf08c6e]{justify-content:space-between;min-height:47px;flex-wrap:wrap}.sidebar__header__clear[data-v-0cf08c6e]{font-size:.8em;min-width:102px}@media only screen and (min-width: 768px) and (max-width: 770px){.sidebar__header__clear[data-v-0cf08c6e]{margin-top:20px}}.sidebar__inline-selecors[data-v-0cf08c6e]{display:flex}\n", ""]);

// exports
